import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

import { Hook } from './hooks-wireup';

export abstract class OnRouteResolve<TModel> extends Hook {
    protected readonly destroyRef = inject(DestroyRef);

    constructor(protected route: ActivatedRoute) {
        super();
    }

    preNgOnInit(): void {
        this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(({ model }) => this.onRouteResolved(model));
    }

    abstract onRouteResolved(model: TModel): void;
}
